const wowApp = require('angular').module('wowApp.digitalpay');

const { creditCardComponentDefinition } = require('./credit-card.component');
const { creditCardAddPaymentComponentDefinition } = require('./credit-card-add-payment.component');
const { creditCardItemInlineCvvComponentDefinition } = require('./credit-card-item-inline-cvv.component');
const { creditCardItemPaymentComponentDefinition } = require('./credit-card-item-payment.component');
const { creditCardCvvDialogComponentDefinition } = require('./credit-card-cvv-dialog.component');

wowApp.component('wowCreditCard', creditCardComponentDefinition);
wowApp.component('wowCreditCardAddPayment', creditCardAddPaymentComponentDefinition);
wowApp.component('wowCreditCardItemInlineCvv', creditCardItemInlineCvvComponentDefinition);
wowApp.component('wowCreditCardItemPayment', creditCardItemPaymentComponentDefinition);
wowApp.component('wowCreditCardCvvDialog', creditCardCvvDialogComponentDefinition);



// WEBPACK FOOTER //
// ./src/digitalpay/creditcard/index.js